export default __webpack_public_path__ + "static/media/icon-info-cicle.99b4f705.svg";